module.exports = __webpack_public_path__ + "static/image/history/pc/201707@3x.jpg?b3619a79";